// extracted by css-extract-rspack-plugin
export default {"like":"vUyl_a","not-clickable":"TNWv_y","notClickable":"TNWv_y","likebutton":"jRTTQv","likes":"BcVPrU"};